// This file contains a Pixi manifest with bundles for all in-game assets.
import type { AssetsManifest } from "pixi.js";

import Board_BG_Default from "@/game/assets/boards/classic/BG.png";
import Board_Default from "@/game/assets/boards/classic/Board.png";
import Checker_Default2 from "@/game/assets/boards/classic/Checker_Opponent.png";
import Checker_Default1 from "@/game/assets/boards/classic/Checker_Player.png";

export const BoardManifest: AssetsManifest = {
  bundles: [
    {
      name: "boards-default",
      assets: [
        {
          alias: "board-bg",
          src: Board_BG_Default
        },
        {
          alias: "board",
          src: Board_Default
        },
        {
          alias: "board-checker-local",
          src: Checker_Default1
        },
        {
          alias: "board-checker-opponent",
          src: Checker_Default2
        }
      ]
    }
  ]
};
